import '../../input.css'
import LeanPyramidSection from './LeanPyramidSection'
import ModulesSection from './ModulesSection/ModulesSection'
import TeacherSection from './TeacherSection'
import LeanPyramidHistory from './LeanPyramidHistory'
import LeanPyramidBenefitsSection from './LeanPyramidBenefitsSection'
import FaqSection from './FaqSection'
import AcademyNetflixSection from './AcademyNetflixSection'
import BookDemoCta, { BookDemoPrimaryButton } from '../BookDemoCta'

const AcademyPage = () => {
  return (
    <div
      id="home-page"
      className="h-full w-full flex flex-col pt-10 font-Quicksand text-white  bg-vulcan"
    >
      <AcademyNetflixSection />
      <div className="px-6 md:px-16 mt-8">
        <div className="max-w-5xl mx-auto flex justify-center">
          <BookDemoPrimaryButton />
        </div>
      </div>
      <ModulesSection />
      <TeacherSection />
      <LeanPyramidHistory />
      <LeanPyramidSection />
      <LeanPyramidBenefitsSection />
      <FaqSection />
      <div className="px-6 md:px-16 py-12">
        <div className="max-w-5xl mx-auto">
          <BookDemoCta align="center" />
        </div>
      </div>
    </div>
  )
}

export default AcademyPage
